export const isAborted = (error: unknown) => error instanceof Error && error.name === 'AbortError';
